export const PREFERENCE_CUSTOMER_INPUT_MAX_LENGTH = 10
